import { RequireAuth } from '@/features/auth'
import ModuleList from '../components/ModuleList'

import { useWorkspace } from '@/features/workspace/stores/workspace.store'
import { WorkspaceLayout } from './WorkspaceLayout'
import { useProjectStore } from '@/core/project/store/project.store'

const WorkspacePage = () => {
    const { project } = useProjectStore()

    // Project is now loaded by WorkspaceProvider
    if (!project) return null
    return (
        <WorkspaceLayout>
            <div className="flex flex-1 flex-col gap-4 px-6">
                <div className="my-6 flex flex-col gap-2 pl-1">
                    <h2 className="text-lg font-medium text-muted-foreground">
                        Entering your Storyverse,
                    </h2>
                    <h1 className="text-4xl font-extrabold tracking-tight text-primary">
                        {project.title || 'Untitled Project'}
                    </h1>
                    <p className="text-muted-foreground text-lg max-w-prose">
                        Direct, write, and build your masterpiece.
                    </p>
                </div>
                <ModuleList project_id={project.id!.toString()} />
            </div>
        </WorkspaceLayout>
    )
}

export default WorkspacePage
